import React from 'react';
import './TelaVazia.css';

const TelaVazia = ({ onCreateClick }) => {
  return (
    <div className="tela-vazia">
      <div className="tela-vazia-content">
        <div className="tela-vazia-ilustracao">
          <svg
            viewBox="0 0 200 200"
            width="120"
            height="120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Livro/Álbum aberto esquerdo */}
            <path
              d="M 40 60 Q 40 50 50 50 L 100 50 Q 110 50 110 60 L 110 150 Q 110 160 100 160 L 50 160 Q 40 160 40 150 Z"
              stroke="#006437"
              strokeWidth="2.5"
              fill="none"
            />
            <path
              d="M 100 50 L 100 160"
              stroke="#006437"
              strokeWidth="2.5"
            />

            {/* Livro/Álbum aberto direito */}
            <path
              d="M 110 60 Q 110 50 120 50 L 170 50 Q 180 50 180 60 L 180 150 Q 180 160 170 160 L 120 160 Q 110 160 110 150 Z"
              stroke="#FFDF00"
              strokeWidth="2.5"
              fill="none"
            />

            {/* Detalhes decorativos */}
            <circle cx="65" cy="85" r="3" fill="#006437" opacity="0.6" />
            <circle cx="65" cy="115" r="3" fill="#006437" opacity="0.6" />
            <circle cx="145" cy="85" r="3" fill="#FFDF00" opacity="0.8" />
            <circle cx="145" cy="115" r="3" fill="#FFDF00" opacity="0.8" />
          </svg>
        </div>

        <h2 className="tela-vazia-titulo">Oi, você ainda não tem álbuns.</h2>

        <p className="tela-vazia-descricao">
          Crie seu primeiro álbum e comece a marcar as figurinhas que você tem!
        </p>

        <button className="btn-criar-primeiro" onClick={onCreateClick}>
          Criar meu primeiro álbum
        </button>
      </div>
    </div>
  );
};

export default TelaVazia;
